import { createSlice } from '@reduxjs/toolkit';

import actions from './checkout.actions';

import cartPaymentMethod from 'domains/cart_payment_method';

import type { CheckoutSliceInitialState } from './checkout.types';

const initialState: CheckoutSliceInitialState = {
  initialized: false,
  submitStatus: 'idle',
  confirmationDetails: {
    status: 'idle',
  },
};

const slice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actions.initCheckout.fulfilled, (state) => {
        return { ...state, initialized: true };
      })
      .addCase(actions.initConfirmation.fulfilled, (state) => {
        return { ...state, initialized: true };
      })

      .addCase(cartPaymentMethod.actions.save.fulfilled, (state, { payload }) => {
        return {
          ...state,
          // If the submit error is populated, and then we get this action,
          // the user entered new payment data, so we should remove the error state
          // and let them try to submit again
          submitStatus: state.submitError ? 'idle' : state.submitStatus,
        };
      })
      .addCase(actions.saveConfirmationDetails.pending, (state) => {
        return { ...state, confirmationDetails: { status: 'loading' } };
      })

      .addCase(actions.saveConfirmationDetails.fulfilled, (state) => {
        return { ...state, confirmationDetails: { status: 'idle' } };
      })

      .addCase(actions.submitOrder.pending, (state) => {
        return { ...state, submitStatus: 'submitting' };
      })
      .addCase(actions.submitOrder.fulfilled, (state) => {
        return { ...state, submitStatus: 'success' };
      })
      .addCase(actions.submitOrder.rejected, (state, { payload }) => {
        // An order submit rejection with a payload means we were given an error
        // specifically regarding a braintree payment issue
        return {
          ...state,
          submitStatus: 'error',
          submitError: payload ? `Payment Error: ${payload}` : undefined,
        };
      });
  },
});

export default slice;
